// ─── Seção do Banner ─────────────────────────────────────────────────────────
function initBlogBanner() {
  document.querySelectorAll(".blog-banner").forEach((section) => {
    const slidesWrap = section.querySelector(".blog-banner__slides");
    const slides = Array.from(section.querySelectorAll(".blog-banner__slide"));

    if (slides.length < 2 || !slidesWrap) {
      return;
    }

    const dotGroups = slides.map((slide) =>
      Array.from(slide.querySelectorAll(".blog-banner__dot")),
    );

    const AUTOPLAY_DELAY = 5000;
    let autoplayId = null;

    const getActiveIndex = () => {
      const index = slides.findIndex((s) => s.classList.contains("is-active"));
      return index === -1 ? 0 : index;
    };

    const setActive = (index) => {
      const total = slides.length;
      const next = ((index % total) + total) % total;

      slides.forEach((s, i) => s.classList.toggle("is-active", i === next));
      dotGroups.forEach((group) => {
        group.forEach((dot, i) =>
          dot.classList.toggle("is-active", i === next),
        );
      });
    };

    const stopAutoplay = () => {
      if (autoplayId) {
        clearInterval(autoplayId);
        autoplayId = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayId = setInterval(() => {
        setActive(getActiveIndex() + 1);
      }, AUTOPLAY_DELAY);
    };

    // Troca manual (dot ou arraste) reinicia a contagem do autoplay
    const goTo = (index) => {
      setActive(index);
      startAutoplay();
    };

    dotGroups.forEach((group) => {
      group.forEach((dot, i) => {
        dot.addEventListener("click", () => goTo(i));
      });
    });

    // Pausa apenas com o mouse em cima
    section.addEventListener("mouseenter", stopAutoplay);
    section.addEventListener("mouseleave", startAutoplay);

    // ── Arrastar para trocar de slide (mouse e touch via Pointer Events) ────────
    const DRAG_THRESHOLD = 60;
    let pointerId = null;
    let startX = 0;
    let dragging = false;

    slidesWrap.addEventListener("pointerdown", (event) => {
      pointerId = event.pointerId;
      startX = event.clientX;
      dragging = true;
      slidesWrap.setPointerCapture(pointerId);
    });

    slidesWrap.addEventListener("pointermove", (event) => {
      if (!dragging || event.pointerId !== pointerId) {
        return;
      }

      // Evita seleção de texto/drag de imagem nativo durante o arraste
      event.preventDefault();
    });

    slidesWrap.addEventListener("pointerup", (event) => {
      if (!dragging || event.pointerId !== pointerId) {
        return;
      }

      dragging = false;
      const deltaX = event.clientX - startX;

      if (Math.abs(deltaX) >= DRAG_THRESHOLD) {
        const index = getActiveIndex();
        goTo(deltaX < 0 ? index + 1 : index - 1);
      }
    });

    slidesWrap.addEventListener("pointercancel", () => {
      dragging = false;
    });

    setActive(getActiveIndex());
    startAutoplay();
  });
}

// ─── Seção dos Posts (+ Seção de Busca) ──────────────────────────────────────
function initBlogPosts() {
  const section = document.querySelector("[data-blog-posts]");
  const content = section?.querySelector("[data-blog-posts-content]");
  const filters = section
    ? Array.from(section.querySelectorAll(".blog-posts__filter"))
    : [];
  const searchInput = document.querySelector("[data-blog-search-input]");

  if (!section || !content) {
    return;
  }

  const ajaxUrl = section.dataset.ajaxUrl;
  const nonce = section.dataset.nonce;
  const baseUrl = section.dataset.baseUrl;

  let currentCategoria = section.dataset.categoria || "";
  let currentBusca = section.dataset.busca || "";

  const setActiveFilter = (categoria) => {
    filters.forEach((filter) => {
      const url = new URL(filter.href, window.location.origin);
      filter.classList.toggle(
        "is-active",
        (url.searchParams.get("categoria") || "") === categoria,
      );
    });
  };

  const buildUrl = (categoria, pagina, busca) => {
    const url = new URL(baseUrl, window.location.origin);

    if (categoria) {
      url.searchParams.set("categoria", categoria);
    }

    if (busca) {
      url.searchParams.set("busca", busca);
    }

    if (pagina && pagina !== "1") {
      url.searchParams.set("pagina", pagina);
    }

    return `${url.pathname}${url.search}`;
  };

  const loadContent = (categoria, pagina, busca, pushUrl, scrollAfter) => {
    currentCategoria = categoria;
    currentBusca = busca;

    const body = new URLSearchParams({
      action: "utrax_filter_blog_posts",
      nonce,
      categoria,
      pagina,
      busca,
      base_url: baseUrl,
    });

    content.classList.add("is-loading");

    fetch(ajaxUrl, { method: "POST", body })
      .then((response) => response.json())
      .then((json) => {
        if (!json.success) {
          return;
        }

        content.innerHTML = json.data.html;
        setActiveFilter(categoria);

        if (pushUrl) {
          window.history.pushState({ categoria, pagina, busca }, "", pushUrl);
        }

        if (scrollAfter) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .finally(() => {
        content.classList.remove("is-loading");
      });
  };

  const paramsFromLink = (link) => {
    const url = new URL(link.href, window.location.origin);

    return {
      categoria: url.searchParams.get("categoria") || "",
      pagina: url.searchParams.get("pagina") || "1",
      busca: url.searchParams.get("busca") || "",
      pushUrl: `${url.pathname}${url.search}`,
    };
  };

  section.addEventListener("click", (event) => {
    const filterLink = event.target.closest(".blog-posts__filter");
    const pageLink = event.target.closest(
      ".blog-posts__pagination a.page-numbers",
    );

    if (!filterLink && !pageLink) {
      return;
    }

    event.preventDefault();

    if (filterLink) {
      const url = new URL(filterLink.href, window.location.origin);
      const categoria = url.searchParams.get("categoria") || "";
      const pushUrl = buildUrl(categoria, "1", currentBusca);
      loadContent(categoria, "1", currentBusca, pushUrl);
      return;
    }

    const { categoria, pagina, busca, pushUrl } = paramsFromLink(pageLink);
    loadContent(categoria, pagina, busca, pushUrl, true);
  });

  if (searchInput) {
    const SEARCH_DEBOUNCE = 300;
    let debounceId = null;

    searchInput.addEventListener("input", () => {
      const busca = searchInput.value.trim();

      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        const pushUrl = buildUrl(currentCategoria, "1", busca);
        loadContent(currentCategoria, "1", busca, pushUrl);
      }, SEARCH_DEBOUNCE);
    });
  }

  window.addEventListener("popstate", () => {
    const url = new URL(window.location.href);
    const busca = url.searchParams.get("busca") || "";

    loadContent(
      url.searchParams.get("categoria") || "",
      url.searchParams.get("pagina") || "1",
      busca,
      null,
    );

    if (searchInput) {
      searchInput.value = busca;
    }
  });
}

// ─── Single Post — Copiar link ───────────────────────────────────────────────
function initSinglePostShare() {
  const btn = document.querySelector("[data-copy-link]");
  const label = btn?.querySelector("[data-copy-link-label]");

  if (!btn || !label) {
    return;
  }

  const defaultLabel = label.textContent;

  btn.addEventListener("click", () => {
    const url = btn.dataset.copyLink || window.location.href;

    navigator.clipboard.writeText(url).then(() => {
      btn.classList.add("is-copied");
      label.textContent = "Link copiado!";

      setTimeout(() => {
        btn.classList.remove("is-copied");
        label.textContent = defaultLabel;
      }, 2000);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initBlogBanner();
  initBlogPosts();
  initSinglePostShare();
});
